import { FormlyFieldConfig } from '@ngx-formly/core'
import { STATE_PROVINCE_LIST } from 'src/data/address.form'

export const US_PHONE_NUMBER_FIELD = {
	type: 'masked-input',
	props: {
		mask: '(000) 000-0000',
		label: 'Phone Number',
	}
}

export const EMAIL_FIELD = {
	type: 'input',
	props: {
		label: 'Email',
		pattern: `\\w+([\\-+._']\\w+)*@\\w+([\\-._]\\w+)*\\.\\w+([\\-.]\\w+)*`
	}
}

export const FIRST_NAME_FIELD = {
	'type': 'name-field',
	'props': {
		'label': 'First Name',
	}
}

export const MIDDLE_NAME_FIELD = {
	'type': 'name-field',
	'props': {
		'label': 'Middle Name',
	}
}

export const LAST_NAME_FIELD = {
	'type': 'name-field',
	'props': {
		'label': 'Last Name',
	}
}

export const US_ADDRESS_FIELDS = [
	{
		fieldGroup: [
			{
				key: 'address_1',
				type: 'input',
				props: {
					label: 'Street Address 1',
					required: true
				},
				className: 'gwc-form__field gwc-form__field--grow',
				validators: {
					validation: [
						'pobox'
					]
				}
			},
			{
				key: 'address_2',
				type: 'input',
				props: {
					label: 'Suite/Apt',
					required: false
				},
				className: 'gwc-form__field gwc-form__field--apt',
				validators: {
					validation: [
						'pobox'
					]
				}
			}
		],
		fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
	},
	{
		fieldGroup: [
			{
				key: 'city',
				type: 'name-field',
				props: {
					label: 'City',
					required: true
				},
				className: 'gwc-form__field gwc-form__field--grow'
			},
			{
				key: 'state',
				type: 'state-province-autocomplete',
				props: {
					required: true,
					parentValue: 'US'
				},
				className: 'gwc-form__field gwc-form__field--grow'
			},
			{
				key: 'zip',
				type: 'input',
				props: {
					label: 'Zip',
					pattern: '[0-9]{5}',
					required: true,
					maxLength: 5
				},
				className: 'gwc-form__field gwc-form__field--apt'
			}
		],
		fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
	}
]

export const EMPLOYMENT_STATUS_FIELD = {
	employer: {
		type: 'input',
		props: {
			label: 'Employer',
			maxLength: 50
		}
	},
	position: {
		type: 'input',
		props: {
			label: 'Position',
			maxLength: 50
		}
	},
	salary: {
		type: 'input',
		props: {
			'min': 0,
			'step': 1,
			type: 'number',
			label: 'MonthlySalary (USD)',
		}
	},
	description: {
		type: 'input',
		props: {
			label: 'Job Description',
			maxLength: 100
		}
	},
	phone_number: US_PHONE_NUMBER_FIELD,
	email: EMAIL_FIELD,
	address: {
		fieldGroup: US_ADDRESS_FIELDS,
	}
}


export const INT_ADDRESS_FIELDS = [
	{
		key: 'country',
		type: 'country-autocomplete',
		props: {
			required: true
		},
		className: 'gwc-form__field gwc-form__field--grow'
	},
	{
		fieldGroup: [
			{
				key: 'address_1',
				type: 'input',
				props: {
					label: 'Street Address 1',
					required: true
				},
				className: 'gwc-form__field gwc-form__field--grow',
				validators: {
					validation: [
						'pobox'
					]
				}
			},
			{
				key: 'address_2',
				type: 'input',
				props: {
					label: 'Suite/Apt',
					required: false
				},
				className: 'gwc-form__field gwc-form__field--apt',
				validators: {
					validation: [
						'pobox'
					]
				}
			}
		],
		fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
	},
	{
		fieldGroup: [
			{
				key: 'city',
				type: 'name-field',
				props: {
					label: 'City',
					required: true
				},
				className: 'gwc-form__field gwc-form__field--grow'
			},
			{
				// countries with a state/province list get the autocomplete
				// (the component hides itself for the rest)
				key: 'state',
				type: 'state-province-autocomplete',
				props: {
					required: true,
					parentKey: 'country'
				},
				className: 'gwc-form__field gwc-form__field--grow'
			},
			{
				// free text for countries without a state/province list
				key: 'state',
				type: 'input',
				props: {
					label: 'State/Province',
					required: true
				},
				className: 'gwc-form__field gwc-form__field--grow',
				expressions: {
					'hide': (field: FormlyFieldConfig) => {
						const country = field.formControl?.parent?.get('country')?.value || field.model?.country

						return !!(STATE_PROVINCE_LIST as { [key: string]: unknown })[country]
					}
				}
			},
			{
				key: 'zip',
				type: 'input',
				props: {
					label: 'Zip',
					required: true
				},
				className: 'gwc-form__field gwc-form__field--apt',
				expressions: {
					'props.label': (field: FormlyFieldConfig) => {
						const country = field.formControl?.parent?.get('country')?.value || field.model?.country

						return country === 'CA' ? 'Postal Code' : 'Zip'
					},
					'props.pattern': (field: FormlyFieldConfig) => {
						const country = field.formControl?.parent?.get('country')?.value || field.model?.country

						return country === 'CA' ? '[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz] \\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]\\d' : country === 'US' ? '[0-9]{5}' : undefined
					},
					'props.maxLength': (field: FormlyFieldConfig) => {
						const country = field.formControl?.parent?.get('country')?.value || field.model?.country

						return country === 'CA' ? 7 : country === 'US' ? 5 : 15
					}
				}
			}
		],
		fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
	}
]
